export const templesGroup2 = [
  {
    slNo: "13",
    slug: "guruvayur-temple",
    generalInfo: {
      templeName: "Guruvayur Sri Krishna Temple",
      templeDescription: "Guruvayur Sri Krishna Temple in Thrissur district, Kerala, is one of South India's major Krishna pilgrimage centres. The presiding deity, popularly called Guruvayurappan, is worshipped as Lord Krishna/Vishnu. The temple is managed by Guruvayur Devaswom. Entry to the inner temple is restricted to Hindus, and a traditional dress code applies. Kerala Tourism lists regular darshan hours from 3:00 AM to 12:30 PM and 4:30 PM to 9:15 PM; festival schedules can vary.",
      location: "Guruvayur, Thrissur district, Kerala",
      deity: "Lord Krishna (Guruvayurappan)",
      trekPoints: [],
      dressCode: "Men: plain white/cream dhoti; shirts, trousers, jeans, pyjamas, lungis and footwear are not allowed inside. Women: sari, skirt with blouse or churidar. Follow current Devaswom instructions."
    },
    timeInfo: {
      bestTime: "October - February for relatively pleasant weather.",
      peakTime: "Guruvayur Ekadashi, Krishna Janmashtami/Ashtami Rohini, Vishu and major holidays/weekends."
    },
    footfall: { monthlyFootfalls: [] },
    registrationProcess: [
      {
        name: "General Darshan",
        description: "General darshan is through the temple queue. A virtual-queue system operates during selected seasons.",
        isMandatory: false,
        method: "Onsite / Virtual queue when offered",
        cost: "Free",
        requiredDocs: "Check current booking instructions",
        location: "Temple queue",
        website: "https://guruvayurdevaswom.nic.in/",
        validity: "Current visit"
      }
    ],
    prerequisites: [
      { name: "Temple Entry", description: "Only Hindus are permitted inside the temple." },
      { name: "Dress Code", description: "Traditional temple dress rules are strictly enforced." }
    ],
    temperature: {
      monthlyTemperatures: [
        { month: "Jan", high: "31.8", low: "23.8" },
        { month: "Feb", high: "32.3", low: "24.4" },
        { month: "Mar", high: "32.2", low: "25.5" },
        { month: "Apr", high: "31.0", low: "25.9" },
        { month: "May", high: "29.8", low: "25.7" },
        { month: "Jun", high: "27.7", low: "24.6" },
        { month: "Jul", high: "27.1", low: "24.1" },
        { month: "Aug", high: "27.2", low: "24.0" },
        { month: "Sep", high: "27.9", low: "24.1" },
        { month: "Oct", high: "28.5", low: "24.1" },
        { month: "Nov", high: "29.5", low: "24.1" },
        { month: "Dec", high: "30.7", low: "23.9" }
      ]
    },
    templeTimings: {
      mandirTimings: {
        morningOpen: "03:00 AM",
        morningClose: "12:30 PM",
        eveningOpen: "04:30 PM",
        eveningClose: "09:15 PM"
      },
      gufaTimings: { morningOpen: "N/A", morningClose: "N/A", eveningOpen: "N/A", eveningClose: "N/A" },
      aartis: [
        { name: "Nirmalyam / Opening rituals", time: "From 03:00 AM" },
        { name: "Daily poojas and seeveli", time: "Schedule varies; check Guruvayur Devaswom" }
      ]
    },
    transportation: [
      { mode: "Train", startPoint: "Guruvayur Railway Station", endPoint: "Guruvayur Temple", distanceKm: 1.0, duration: "Approx. 5-10 mins", cost: "N/A" },
      { mode: "Flight", startPoint: "Cochin International Airport", endPoint: "Guruvayur", distanceKm: 87, duration: "Approx. 2-3 hrs by road", cost: "Cab ₹1,886 onwards" },
      { mode: "Road", startPoint: "Thrissur", endPoint: "Guruvayur", distanceKm: 29, duration: "Approx. 45-60 mins", cost: "₹55 onwards by bus" }
    ],
    accommodation: [
      { type: "ISKCON Guest House", location: "About 300 m from Guruvayur KSRTC bus stand", costRange: "₹1,200 non-AC / ₹1,800 AC", bookingInfo: "Food and parking listed." },
      { type: "Private Hotel", location: "Hotel Brahmaputhra, approx. 0.3 km from Temple", costRange: "Varies by date", bookingInfo: "Nearby private accommodation." }
    ],
    gates: [
      { name: "East Gate (Kizhakkenada)", description: "Major approach/entry side of temple complex.", location: "East side", isOpen: true },
      { name: "West Gate (Padinjarenada)", description: "Major temple approach gate.", location: "West side", isOpen: true }
    ],
    facilities: [
      { name: "Locker / Cloak Room", description: "Lockers available outside for electronic equipment.", isAvailable: true },
      { name: "Shoe Stand", description: "Designated footwear storage available.", isAvailable: true },
      { name: "Drinking Water", description: "Drinking water available.", isAvailable: true },
      { name: "Toilets", description: "Public facilities available around pilgrimage area.", isAvailable: true },
      { name: "Restaurants / Food", description: "Vegetarian food and prasadam options widely available.", isAvailable: true },
      { name: "Prasad", description: "Temple prasadam available through Devaswom counters.", isAvailable: true },
      { name: "Medical Facility", description: "Guruvayur Devaswom Medical Centre ~0.5 km. Sreekrishna Medicals ~0.3 km.", isAvailable: true }
    ],
    specialServices: [
      { name: "Virtual Queue", description: "Trial virtual-queue darshan service available on notified dates.", price: "Free" }
    ],
    nearbyPlaces: [
      { name: "Mammiyur Mahadeva Temple", description: "Important Shiva temple traditionally visited as part of pilgrimage." },
      { name: "Punnathur Kotta", description: "Guruvayur Devaswom elephant camp near Guruvayur." }
    ],
    images: { thumbnailImage: "https://img.traveltriangle.com/blog/wp-content/uploads/2024/06/hotels-near-Guruvayur-temple.jpg" },
    management: {
      trustName: "Guruvayur Devaswom",
      website: "https://guruvayurdevaswom.nic.in/",
      contactNumber: "0487-2556335; 0487-2556347; 0487-2556365"
    }
  },
  {
    slNo: "14",
    slug: "banke-bihari",
    generalInfo: {
      templeName: "Shri Banke Bihari Mandir",
      templeDescription: "Shri Banke Bihari Mandir in Vrindavan, Mathura district, Uttar Pradesh, is a major Krishna temple associated with the saint Swami Haridas. The deity is worshipped as Thakur Shri Banke Bihariji. Seasonal darshan timings, festival notices and crowd advisories vary through the year. There is no regular VIP darshan system. Mobile phones, electronic gadgets, footwear and leather items are prohibited in and around the temple premises.",
      location: "Vrindavan, Mathura district, Uttar Pradesh",
      deity: "Lord Krishna (Thakur Shri Banke Bihariji)",
      trekPoints: [],
      dressCode: "Wear clean, modest clothing. Footwear and leather items are prohibited in and around the temple premises."
    },
    timeInfo: {
      bestTime: "October - March for cooler weather; visit on a normal weekday for lower crowd.",
      peakTime: "Ekadashi, Poornima, Amavasya, weekends/public holidays, annual festivals, and December 20 - January 5."
    },
    footfall: { monthlyFootfalls: [] },
    registrationProcess: [
      {
        name: "General Darshan",
        description: "Registration is not required for general darshan. Follow the physical queue and current crowd-control instructions.",
        isMandatory: false,
        method: "Onsite",
        cost: "Free general darshan",
        requiredDocs: "N/A",
        location: "Temple queue",
        website: "https://www.bihariji.org/",
        validity: "Current visit"
      }
    ],
    prerequisites: [
      { name: "Prohibited Items", description: "Do not carry mobile phones, electronic gadgets, umbrellas, footwear or leather items into/around the temple premises." }
    ],
    temperature: {
      monthlyTemperatures: [
        { month: "Jan", high: "20.3", low: "7.9" },
        { month: "Feb", high: "24.2", low: "10.8" },
        { month: "Mar", high: "30.6", low: "15.6" },
        { month: "Apr", high: "37.3", low: "21.4" },
        { month: "May", high: "40.0", low: "25.9" },
        { month: "Jun", high: "38.6", low: "28.2" },
        { month: "Jul", high: "33.7", low: "26.9" },
        { month: "Aug", high: "32.1", low: "25.9" },
        { month: "Sep", high: "32.4", low: "24.2" },
        { month: "Oct", high: "32.2", low: "19.5" },
        { month: "Nov", high: "27.8", low: "14.5" },
        { month: "Dec", high: "22.5", low: "9.5" }
      ]
    },
    templeTimings: {
      mandirTimings: {
        morningOpen: "07:45 AM (Summer) / 08:45 AM (Winter)",
        morningClose: "12:00 Noon (Summer) / 01:00 PM (Winter)",
        eveningOpen: "05:30 PM (Summer) / 04:30 PM (Winter)",
        eveningClose: "09:30 PM (Summer) / 08:30 PM (Winter)"
      },
      gufaTimings: { morningOpen: "N/A", morningClose: "N/A", eveningOpen: "N/A", eveningClose: "N/A" },
      aartis: [
        { name: "Shringar Aarti", time: "07:55 AM (Summer) / 08:55 AM (Winter)" },
        { name: "Rajbhog Aarti", time: "11:55 AM (Summer) / 12:55 PM (Winter)" },
        { name: "Shayan Aarti", time: "09:25 PM (Summer) / 08:25 PM (Winter)" }
      ]
    },
    transportation: [
      { mode: "Train", startPoint: "Mathura Junction", endPoint: "Vrindavan / Banke Bihari", distanceKm: 13, duration: "Approx. 30-45 mins", cost: "Cab ₹760 onwards" },
      { mode: "Flight", startPoint: "Indira Gandhi International Airport, Delhi", endPoint: "Vrindavan", distanceKm: 160, duration: "Approx. 3-4 hrs by road", cost: "Taxi approx. ₹3,000-₹3,700" }
    ],
    accommodation: [
      { type: "Ashram / Guest House", location: "Parmarth Nikunj Bhavan, Banke Bihari Colony", costRange: "2-bed AC family room from ₹1,700", bookingInfo: "Food, parking, hot water and drinking water listed." }
    ],
    gates: [
      { name: "Gate No. 5", description: "Used for approved darshan-assistance cases.", location: "Temple complex", isOpen: true }
    ],
    facilities: [
      { name: "Locker / Cloak Room", description: "Paid locker / cloak-room facility available near temple approach.", isAvailable: true },
      { name: "Shoe Stand", description: "Footwear storage available outside controlled area.", isAvailable: true },
      { name: "Drinking Water", description: "Free drinking water available.", isAvailable: true },
      { name: "Toilets", description: "Paid toilet facility available.", isAvailable: true },
      { name: "Restaurants / Food", description: "Numerous vegetarian eateries available in Vrindavan.", isAvailable: true },
      { name: "Prasad", description: "Offerings/sewa arranged through authorised temple sewa adhikaris.", isAvailable: true },
      { name: "Wheelchair", description: "Wheelchair assistance available outside Sneh Bihari Mandir by prior coordination.", isAvailable: true }
    ],
    specialServices: [
      { name: "Darshan Assistance", description: "Assistance requested for elderly or disabled devotees.", price: "N/A" }
    ],
    nearbyPlaces: [
      { name: "Nidhivan", description: "Sacred Krishna-Radha site in Vrindavan." },
      { name: "ISKCON Krishna-Balaram Mandir", description: "Major Krishna temple in Vrindavan." },
      { name: "Prem Mandir", description: "Large Radha-Krishna temple complex in Vrindavan." }
    ],
    images: { thumbnailImage: "https://vrindavandarshan.in/wp-content/uploads/2024/10/banke-bihari-temple-vrindavan-8.jpg" },
    management: {
      trustName: "Shri Banke Bihari Mandir management",
      website: "https://www.bihariji.org/",
      contactNumber: "+91-9917028832; +91-8958422967"
    }
  },
  {
    slNo: "15",
    slug: "siddhivinayak-mumbai",
    generalInfo: {
      templeName: "Shree Siddhivinayak Ganapati Mandir",
      templeDescription: "Shree Siddhivinayak Ganapati Mandir at Prabhadevi, Mumbai, is one of India's best-known Ganesh temples. The shrine is managed by the Shree Siddhivinayak Ganapati Temple Trust, a government-controlled trust governed by the Maharashtra state Act of 1980. The Trust publishes separate schedules for normal days, Tuesdays and Ganesh-related observances, operates a mobile app, and offers bookable poojas.",
      location: "Prabhadevi, Mumbai, Maharashtra",
      deity: "Lord Ganesha (Shree Siddhivinayak)",
      trekPoints: [],
      dressCode: "Modest temple-appropriate clothing recommended."
    },
    timeInfo: {
      bestTime: "November - February for relatively pleasant Mumbai weather; weekday mornings other than Tuesday are generally easier.",
      peakTime: "Tuesdays, Sankashti Chaturthi, Ganesh Chaturthi, Maghi Ganesh Jayanti, New Year and major holidays."
    },
    footfall: { monthlyFootfalls: [] },
    registrationProcess: [
      {
        name: "General Darshan",
        description: "Walk-in darshan is available during temple hours; the app also supports darshan appointment features.",
        isMandatory: false,
        method: "Onsite / app",
        cost: "Free general darshan",
        requiredDocs: "N/A",
        location: "Temple queue",
        website: "https://www.siddhivinayak.org/",
        validity: "Current visit"
      }
    ],
    prerequisites: [],
    temperature: {
      monthlyTemperatures: [
        { month: "Jan", high: "31.2", low: "16.9" },
        { month: "Feb", high: "31.7", low: "18.1" },
        { month: "Mar", high: "33.1", low: "21.1" },
        { month: "Apr", high: "33.4", low: "24.2" },
        { month: "May", high: "33.7", low: "27.0" },
        { month: "Jun", high: "32.5", low: "26.6" },
        { month: "Jul", high: "30.4", low: "25.5" },
        { month: "Aug", high: "30.2", low: "25.2" },
        { month: "Sep", high: "30.9", low: "24.9" },
        { month: "Oct", high: "33.6", low: "23.9" },
        { month: "Nov", high: "34.1", low: "21.4" },
        { month: "Dec", high: "32.6", low: "18.4" }
      ]
    },
    templeTimings: {
      mandirTimings: {
        morningOpen: "06:00 AM (Wed-Mon); 03:15 AM Tuesday",
        morningClose: "12:00 PM before Naivedhya",
        eveningOpen: "12:30 PM after Naivedhya",
        eveningClose: "After 09:50 PM Shejaarti; Tuesday until 11:30 PM"
      },
      gufaTimings: { morningOpen: "N/A", morningClose: "N/A", eveningOpen: "N/A", eveningClose: "N/A" },
      aartis: [
        { name: "Kakad Aarti", time: "05:30 AM - 06:00 AM (Wed-Mon); 05:00 AM - 05:30 AM Tuesday" },
        { name: "Naivedhya", time: "12:05 PM - 12:30 PM" },
        { name: "Evening Dhup Aarti", time: "07:00 PM - 07:10 PM" },
        { name: "Evening Aarti", time: "07:30 PM - 08:00 PM (Wed-Mon)" },
        { name: "Shejaarti", time: "09:50 PM (Wed-Mon); 11:45 PM Tuesday" }
      ]
    },
    transportation: [
      { mode: "Train", startPoint: "Dadar Railway Station", endPoint: "Siddhivinayak Temple", distanceKm: 2.5, duration: "Approx. 10-20 mins", cost: "Taxi approx. ₹230-₹280" },
      { mode: "Flight", startPoint: "Chhatrapati Shivaji Maharaj International Airport", endPoint: "Siddhivinayak", distanceKm: 13, duration: "Approx. 30-60 mins", cost: "Taxi approx. ₹550-₹700" }
    ],
    accommodation: [
      { type: "Private Hotel", location: "Ramee Guestline Hotel Dadar, approx. 1.5 km", costRange: "Varies", bookingInfo: "Nearby private accommodation." }
    ],
    gates: [],
    facilities: [
      { name: "Locker / Cloak Room", description: "Free locker / cloak-room facility available.", isAvailable: true },
      { name: "Shoe Stand", description: "Free shoe stand available.", isAvailable: true },
      { name: "Drinking Water", description: "Free drinking water available.", isAvailable: true },
      { name: "Toilets", description: "Free toilets available.", isAvailable: true },
      { name: "Restaurants / Food", description: "Food options widely available around Prabhadevi.", isAvailable: true },
      { name: "Prasad", description: "Prasad included with several poojas; Mahaprasad services listed.", isAvailable: true }
    ],
    specialServices: [
      { name: "Temple App", description: "Supports live darshan, darshan appointment, video-call pooja.", price: "Free app" },
      { name: "Ashirvachan Pooja", description: "Bookable blessing pooja.", price: "₹1,500" }
    ],
    nearbyPlaces: [
      { name: "Shivaji Park", description: "Major public park in Dadar, close to Prabhadevi." },
      { name: "Worli Sea Face", description: "Popular waterfront area in central Mumbai." }
    ],
    images: { thumbnailImage: "https://static.sanatanprabhat.org/wp-content/uploads/sites/3/2023/12/09225919/800px-Shree_Siddhivinayak_Temple_Mumbai-1.jpg" },
    management: {
      trustName: "Shree Siddhivinayak Ganapati Temple Trust",
      website: "https://www.siddhivinayak.org/",
      contactNumber: "022-62491111; Pooja Booking: 022-62491107"
    }
  },
  {
    slNo: "16",
    slug: "ambaji-temple",
    generalInfo: {
      templeName: "Shri Arasuri Ambaji Mata Temple",
      templeDescription: "Shri Arasuri Ambaji Mata Temple at Ambaji in Banaskantha district, Gujarat, is a major Shakti pilgrimage centre dedicated to Maa Amba and traditionally counted among the Shakti Peethas. The shrine is managed by Shri Arasuri Ambaji Mata Devasthan Trust. The Trust operates a digital platform for live darshan, schedules, prasad and donations.",
      location: "Ambaji, Banaskantha district, Gujarat",
      deity: "Maa Amba / Arasuri Ambaji",
      trekPoints: [
        { name: "Ambaji Temple", distanceKm: 0 },
        { name: "Gabbar Hill", distanceKm: 4 }
      ],
      dressCode: "Modest temple-appropriate clothing recommended."
    },
    timeInfo: {
      bestTime: "October - March for cooler weather.",
      peakTime: "Bhadarvi Poonam fair, Navratri, Purnima days and major holidays."
    },
    footfall: { monthlyFootfalls: [] },
    registrationProcess: [
      {
        name: "General Darshan",
        description: "General darshan available during published sessions; no compulsory advance registration.",
        isMandatory: false,
        method: "Onsite",
        cost: "Free",
        requiredDocs: "N/A",
        location: "Temple queue",
        website: "https://ambajitemple.in/",
        validity: "Current visit"
      }
    ],
    prerequisites: [],
    temperature: {
      monthlyTemperatures: [
        { month: "Jan", high: "24.7", low: "10.2" },
        { month: "Feb", high: "27.4", low: "12.6" },
        { month: "Mar", high: "32.1", low: "16.8" },
        { month: "Apr", high: "36.4", low: "21.1" },
        { month: "May", high: "37.8", low: "24.1" },
        { month: "Jun", high: "35.2", low: "25.4" },
        { month: "Jul", high: "29.7", low: "24.0" },
        { month: "Aug", high: "28.2", low: "23.1" },
        { month: "Sep", high: "29.8", low: "22.2" },
        { month: "Oct", high: "31.8", low: "19.3" },
        { month: "Nov", high: "29.1", low: "15.7" },
        { month: "Dec", high: "25.8", low: "11.6" }
      ]
    },
    templeTimings: {
      mandirTimings: {
        morningOpen: "08:00 AM (after morning Aarti)",
        morningClose: "11:30 AM",
        eveningOpen: "12:30 PM (afternoon) / 07:30 PM (evening)",
        eveningClose: "09:00 PM"
      },
      gufaTimings: { morningOpen: "N/A", morningClose: "N/A", eveningOpen: "N/A", eveningClose: "N/A" },
      aartis: [
        { name: "Morning Aarti", time: "Approx. 07:30 AM - 08:00 AM" },
        { name: "Evening Aarti", time: "07:00 PM - 07:30 PM" }
      ]
    },
    transportation: [
      { mode: "Train", startPoint: "Abu Road Railway Station", endPoint: "Ambaji", distanceKm: 20, duration: "Approx. 35-45 mins", cost: "Bus approx. ₹65-₹150; taxi approx. ₹440-₹550" },
      { mode: "Flight", startPoint: "Maharana Pratap Airport, Udaipur", endPoint: "Ambaji", distanceKm: 167, duration: "Approx. 2.5-3 hrs", cost: "Taxi approx. ₹3,300-₹4,100" },
      { mode: "Ropeway", startPoint: "Gabbar foothill", endPoint: "Gabbar Hill", distanceKm: 0, duration: "Short ride", cost: "Check counter" }
    ],
    accommodation: [
      { type: "Patidar Bhavan", location: "About 500 m from Ambaji bus stand", costRange: "₹500-₹1,000 for 2-3 bed rooms", bookingInfo: "Verify availability for travel dates." }
    ],
    gates: [],
    facilities: [
      { name: "Drinking Water", description: "Available in pilgrimage area.", isAvailable: true },
      { name: "Toilets", description: "Public facilities available.", isAvailable: true },
      { name: "Restaurants / Food", description: "Vegetarian food options available in town.", isAvailable: true },
      { name: "Prasad", description: "Mohanthal prasad can be ordered through digital platform.", isAvailable: true },
      { name: "Medical Facility", description: "Shri Ambaji Trust General Hospital ~2 km. Ambica Medical Store ~0.3 km.", isAvailable: true }
    ],
    specialServices: [
      { name: "Ambaji Temple App", description: "Provides darshan timings, live darshan, online prasad, donations.", price: "Free" }
    ],
    nearbyPlaces: [
      { name: "Gabbar Hill Shaktipeeth", description: "Sacred hill associated with Ambaji, about 4 km away." },
      { name: "Kumbhariyaji Jain Temples", description: "Historic Jain temple complex near Ambaji." }
    ],
    images: { thumbnailImage: "https://images.indianexpress.com/2023/03/ambaji-temple.jpg?w=1200" },
    management: {
      trustName: "Shri Arasuri Ambaji Mata Devasthan Trust",
      website: "https://ambajitemple.in/",
      contactNumber: "02749-262236; 02749-262590"
    }
  },
  {
    slNo: "17",
    slug: "kalika-mata-pavagadh",
    generalInfo: {
      templeName: "Shree Kalika Mataji Temple, Pavagadh",
      templeDescription: "Shree Kalika Mataji Temple stands on Pavagadh Hill in Panchmahal district, Gujarat, and is one of Gujarat's major Shakti pilgrimage centres. The temple Trust identifies it as a Shakti Peetha and manages darshan, online donation, live darshan and ropeway-ticket links. The current schedule is 6:00 AM to 7:30 PM daily, with Mangla Aarti at opening and Sandhya Aarti at 7:00 PM. A ropeway from Manchi helps pilgrims cover the steep hill approach.",
      location: "Pavagadh Hill, Panchmahal district, Gujarat",
      deity: "Maa Kalika / Mahakali",
      trekPoints: [
        { name: "Pavagadh / Manchi ropeway base", distanceKm: 0 },
        { name: "Ropeway upper station", distanceKm: 0.8 },
        { name: "Kalika Mata Temple", distanceKm: 1.0 }
      ],
      dressCode: "Modest temple-appropriate clothing recommended."
    },
    timeInfo: {
      bestTime: "October - February for cooler weather.",
      peakTime: "Navratri, Chaitra Navratri, Purnima days and major holidays."
    },
    footfall: { monthlyFootfalls: [] },
    registrationProcess: [
      { name: "General Darshan", description: "No compulsory advance registration found.", isMandatory: false, method: "Onsite", cost: "Free", requiredDocs: "N/A", location: "Temple queue", website: "https://www.pavagadhtemple.in/", validity: "Current visit" }
    ],
    prerequisites: [],
    temperature: {
      monthlyTemperatures: [
        { month: "Jan", high: "28", low: "14" },
        { month: "Feb", high: "31", low: "16" },
        { month: "Mar", high: "36", low: "21" },
        { month: "Apr", high: "39", low: "25" },
        { month: "May", high: "40", low: "28" },
        { month: "Jun", high: "36", low: "27" },
        { month: "Jul", high: "32", low: "26" },
        { month: "Aug", high: "30", low: "25" },
        { month: "Sep", high: "32", low: "25" },
        { month: "Oct", high: "34", low: "22" },
        { month: "Nov", high: "32", low: "18" },
        { month: "Dec", high: "29", low: "15" }
      ]
    },
    templeTimings: {
      mandirTimings: { morningOpen: "06:00 AM", morningClose: "Continuous darshan", eveningOpen: "Continuous darshan", eveningClose: "07:30 PM" },
      gufaTimings: { morningOpen: "N/A", morningClose: "N/A", eveningOpen: "N/A", eveningClose: "N/A" },
      aartis: [
        { name: "Mangla Aarti", time: "06:00 AM" },
        { name: "Sandhya Aarti", time: "07:00 PM" }
      ]
    },
    transportation: [
      { mode: "Ropeway", startPoint: "Manchi Haveli", endPoint: "Pavagadh upper station", distanceKm: 0.774, duration: "Approx. 6 mins", cost: "Check online fare", extraInfo: "Stated capacity 1,250 passengers/hour." },
      { mode: "Flight", startPoint: "Vadodara Airport", endPoint: "Pavagadh", distanceKm: 49.2, duration: "Approx. 1-1.5 hrs", cost: "Taxi approx. ₹750-₹950" }
    ],
    accommodation: [
      { type: "Dharamshala", location: "Harsiddhi Niwas, Champaner; about 1.4 km from bus stand", costRange: "₹735-₹1,050", bookingInfo: "Parking, CCTV, hot water listed." }
    ],
    gates: [],
    facilities: [
      { name: "Toilets", description: "Facilities available along the developed pilgrimage corridor.", isAvailable: true },
      { name: "Restaurants / Food", description: "Food options available around Manchi/Pavagadh pilgrimage area.", isAvailable: true },
      { name: "Prasad", description: "Temple prasad available onsite.", isAvailable: true },
      { name: "Medical Facility", description: "Shashwat Hospital in Halol ~10 km.", isAvailable: true },
      { name: "Parking", description: "Parking available around the ropeway/base pilgrimage area.", isAvailable: true }
    ],
    specialServices: [
      { name: "Pavagadh Udan Khatola Ropeway", description: "Ropeway from Manchi Haveli to the upper hill reduces the climb.", price: "Check current fare" }
    ],
    nearbyPlaces: [
      { name: "Champaner-Pavagadh Archaeological Park", description: "UNESCO World Heritage archaeological landscape around Pavagadh." }
    ],
    images: { thumbnailImage: "https://images.beyondyatra.com/dest/pavagadh-hill/places/kalika-mata-temple-pavagadh-gujarat-india-gujarat-india_img_3.jpg" },
    management: {
      trustName: "Shree Kalika Mataji Mandir Trust, Pavagadh",
      website: "https://www.pavagadhtemple.in/",
      contactNumber: "9099091042; 02676-228888; 02676-228899"
    }
  },
  {
    slNo: "18",
    slug: "meenakshi-amman",
    generalInfo: {
      templeName: "Meenakshi Amman Temple",
      templeDescription: "Meenakshi Amman Temple is the principal historic temple of Madurai, dedicated to Goddess Meenakshi and Lord Sundareshwarar. The large temple complex is celebrated for its towering gopurams, sculpted halls and the Thousand Pillared Hall. It remains an active place of worship under the Tamil Nadu Hindu Religious and Charitable Endowments Department.",
      location: "Madurai, Tamil Nadu",
      deity: "Goddess Meenakshi and Lord Sundareshwarar",
      trekPoints: [],
      dressCode: "Modest traditional or formal clothing recommended; shoulders and knees should be covered."
    },
    timeInfo: {
      bestTime: "October - March",
      peakTime: "Chithirai Festival (Apr-May), Navaratri and major festival days"
    },
    footfall: { monthlyFootfalls: [] },
    registrationProcess: [],
    prerequisites: [],
    temperature: {
      monthlyTemperatures: [
        { month: "Jan", high: "31", low: "21" },
        { month: "Feb", high: "33", low: "21" },
        { month: "Mar", high: "36", low: "23" },
        { month: "Apr", high: "38", low: "26" },
        { month: "May", high: "38", low: "27" },
        { month: "Jun", high: "37", low: "27" },
        { month: "Jul", high: "37", low: "26" },
        { month: "Aug", high: "36", low: "26" },
        { month: "Sep", high: "36", low: "25" },
        { month: "Oct", high: "33", low: "24" },
        { month: "Nov", high: "31", low: "23" },
        { month: "Dec", high: "30", low: "21" }
      ]
    },
    templeTimings: {
      mandirTimings: {
        morningOpen: "05:00 AM",
        morningClose: "12:30 PM",
        eveningOpen: "04:00 PM",
        eveningClose: "10:00 PM"
      },
      gufaTimings: { morningOpen: "N/A", morningClose: "N/A", eveningOpen: "N/A", eveningClose: "N/A" },
      aartis: [
        { name: "Morning Pooja / Aarti", time: "From 05:00 AM" },
        { name: "Evening Pooja / Aarti", time: "Evening ritual schedule" }
      ]
    },
    transportation: [
      { mode: "Flight", startPoint: "Madurai Airport", endPoint: "Meenakshi Amman Temple", distanceKm: 11.3, duration: "Approx. 15-25 mins", cost: "₹300-₹360 by taxi" },
      { mode: "Train", startPoint: "Madurai Junction", endPoint: "Meenakshi Amman Temple", distanceKm: 2.4, duration: "Approx. 10 mins", cost: "₹140-₹170 by taxi" }
    ],
    accommodation: [
      { type: "Hotel", location: "Gopuram Grand, near temple", costRange: "Verify current tariff", bookingInfo: "Within a very short walk of the temple." }
    ],
    gates: [
      { name: "Temple Gopuram Entrances", description: "Multiple cardinal entrances used; follow crowd routing.", location: "Meenakshi temple complex", isOpen: true }
    ],
    facilities: [
      { name: "Locker / Cloak Room", description: "Cloakroom/locker services available around temple entry.", isAvailable: true },
      { name: "Shoe Stand", description: "Footwear must be removed; shoe-storage available near entrances.", isAvailable: true },
      { name: "Drinking Water", description: "Drinking water facilities available in/around the complex.", isAvailable: true },
      { name: "Toilets", description: "Public toilets available.", isAvailable: true },
      { name: "Restaurants / Food", description: "Bhagawati Mohans Bhojanalaya and vegetarian restaurants operate close by.", isAvailable: true },
      { name: "Prasad", description: "Temple prasad available.", isAvailable: true },
      { name: "Wheelchair / Accessibility", description: "Accessibility assistance available at selected entrances.", isAvailable: true }
    ],
    specialServices: [
      { name: "Thousand Pillared Hall", description: "Historic hall/museum area within the complex; tickets apply." }
    ],
    nearbyPlaces: [
      { name: "Thirumalai Nayakkar Palace", description: "Approx. 2 km from the temple." },
      { name: "Puthu Mandapam", description: "Historic hall/market immediately east of temple." }
    ],
    images: { thumbnailImage: "https://images.trvl-media.com/place/6104746/9408fbf0-e48c-49bf-afb7-f48b2e66075a.jpg" },
    management: {
      trustName: "Arulmigu Meenakshi Sundareswarar Temple - Tamil Nadu HR&CE",
      website: "https://maduraimeenakshi.hrce.tn.gov.in/",
      contactNumber: "0452-2344360"
    }
  },
  {
    slNo: "20",
    slug: "krishna-janmabhoomi",
    generalInfo: {
      templeName: "Shri Krishna Janmabhoomi Temple Complex",
      templeDescription: "Shri Krishna Janmabhoomi in Mathura marks the traditional birthplace of Lord Krishna and contains the Keshav Dev Temple, Garbha Griha and associated shrines. It is one of the most important Krishna pilgrimage sites in Braj and experiences very heavy security and crowd control, particularly around Janmashtami and Holi. Entry is free, but phones, cameras, larger bags and other prohibited items generally need to be deposited before entering controlled areas.",
      location: "Mathura, Uttar Pradesh",
      deity: "Lord Krishna",
      trekPoints: [],
      dressCode: "Modest traditional or formal clothing recommended."
    },
    timeInfo: {
      bestTime: "October - March",
      peakTime: "Janmashtami, Holi and weekends"
    },
    footfall: { monthlyFootfalls: [] },
    registrationProcess: [],
    prerequisites: [],
    temperature: {
      monthlyTemperatures: [
        { month: "Jan", high: "22", low: "8" },
        { month: "Feb", high: "26", low: "11" },
        { month: "Mar", high: "32", low: "16" },
        { month: "Apr", high: "38", low: "21" },
        { month: "May", high: "42", low: "26" },
        { month: "Jun", high: "40", low: "28" },
        { month: "Jul", high: "35", low: "27" },
        { month: "Aug", high: "33", low: "26" },
        { month: "Sep", high: "34", low: "24" },
        { month: "Oct", high: "34", low: "20" },
        { month: "Nov", high: "29", low: "15" },
        { month: "Dec", high: "24", low: "10" }
      ]
    },
    templeTimings: {
      mandirTimings: {
        morningOpen: "05:00 AM (summer); 05:30 AM (winter)",
        morningClose: "12:00 PM",
        eveningOpen: "04:00 PM (summer); 03:00 PM (winter)",
        eveningClose: "09:30 PM (summer); 08:30 PM (winter)"
      },
      gufaTimings: { morningOpen: "N/A", morningClose: "N/A", eveningOpen: "N/A", eveningClose: "N/A" },
      aartis: [
        { name: "Mangala Aarti", time: "Approx. 05:30 AM summer / 06:00 AM winter" },
        { name: "Evening Aarti", time: "Evening; varies seasonally" }
      ]
    },
    transportation: [
      { mode: "Train", startPoint: "Mathura Junction", endPoint: "Krishna Janmabhoomi", distanceKm: 3.5, duration: "Approx. 5-10 mins", cost: "₹140-₹180 by taxi" },
      { mode: "Flight", startPoint: "Indira Gandhi International Airport, Delhi", endPoint: "Krishna Janmabhoomi", distanceKm: 165, duration: "Approx. 3-4 hrs", cost: "N/A" }
    ],
    accommodation: [
      { type: "Hotel", location: "Hotel Aroma, Mathura, approx. 0.3 km", costRange: "Verify current tariff", bookingInfo: "Janmabhoomi area." }
    ],
    gates: [],
    facilities: [
      { name: "Locker / Cloak Room", description: "Deposit counters/lockers used for phones, cameras and bags before security.", isAvailable: true },
      { name: "Shoe Stand", description: "Footwear must be deposited before entering worship areas.", isAvailable: true },
      { name: "Drinking Water", description: "Drinking water available around pilgrim complex.", isAvailable: true },
      { name: "Toilets", description: "Public toilets available near pilgrimage area.", isAvailable: true },
      { name: "Restaurants / Food", description: "Taste of Mathura and many vegetarian eateries nearby.", isAvailable: true },
      { name: "Prasad", description: "Prasad available at authorized counters/shops.", isAvailable: true }
    ],
    specialServices: [
      { name: "Security Deposit Facility", description: "Phones, cameras and larger bags should be deposited before entering secured zone." }
    ],
    nearbyPlaces: [
      { name: "Dwarkadhish Temple Mathura", description: "Major Krishna temple about 2 km away." },
      { name: "Vishram Ghat", description: "Sacred Yamuna ghat about 2 km away." },
      { name: "Govardhan", description: "Major Braj pilgrimage circuit about 25 km away." }
    ],
    images: { thumbnailImage: "https://vrindavandarshan.in/wp-content/uploads/2023/12/jamanbhumi-mathura.jpg" },
    management: {
      trustName: "Shri Krishna Janmasthan Seva Sansthan",
      website: "https://www.shrikrishnajanmasthan.com/",
      contactNumber: "+91 565 2423714"
    }
  },
  {
    slNo: "21",
    slug: "khatu-shyam",
    generalInfo: {
      templeName: "Shri Khatu Shyam Ji Temple",
      templeDescription: "Shri Khatu Shyam Ji Temple in Khatu, Sikar district, is a major North Indian pilgrimage shrine dedicated to Shyam Baba, worshipped as Barbarika. The temple draws especially large crowds during the Phalguna fair and on Ekadashi-related dates. Darshan hours and aarti timings vary between summer and winter. The shrine is managed by Shri Shyam Mandir Committee.",
      location: "Khatu, Sikar, Rajasthan",
      deity: "Khatu Shyam Ji (Barbarika)",
      trekPoints: [],
      dressCode: "Modest traditional or formal clothing recommended."
    },
    timeInfo: {
      bestTime: "October - March",
      peakTime: "Phalguna Mela (Feb-Mar), Ekadashi dates and weekends"
    },
    footfall: { monthlyFootfalls: [] },
    registrationProcess: [],
    prerequisites: [],
    temperature: {
      monthlyTemperatures: [
        { month: "Jan", high: "22", low: "8" },
        { month: "Feb", high: "26", low: "11" },
        { month: "Mar", high: "32", low: "16" },
        { month: "Apr", high: "37", low: "21" },
        { month: "May", high: "40", low: "26" },
        { month: "Jun", high: "38", low: "27" },
        { month: "Jul", high: "33", low: "26" },
        { month: "Aug", high: "31", low: "24" },
        { month: "Sep", high: "33", low: "23" },
        { month: "Oct", high: "33", low: "19" },
        { month: "Nov", high: "28", low: "14" },
        { month: "Dec", high: "23", low: "9" }
      ]
    },
    templeTimings: {
      mandirTimings: {
        morningOpen: "04:30 AM summer; 05:30 AM winter",
        morningClose: "12:30 PM summer; 01:00 PM winter",
        eveningOpen: "04:00 PM summer; 05:00 PM winter",
        eveningClose: "10:00 PM summer; 09:00 PM winter"
      },
      gufaTimings: { morningOpen: "N/A", morningClose: "N/A", eveningOpen: "N/A", eveningClose: "N/A" },
      aartis: [
        { name: "Mangala Aarti", time: "04:30 AM summer; 05:30 AM winter" },
        { name: "Shringar Aarti", time: "07:00 AM summer; 08:00 AM winter" },
        { name: "Bhog Aarti", time: "12:30 PM" },
        { name: "Sandhya Aarti", time: "07:30 PM summer; 06:30 PM winter" },
        { name: "Shayan Aarti", time: "10:00 PM summer; 09:00 PM winter" }
      ]
    },
    transportation: [
      { mode: "Flight", startPoint: "Jaipur International Airport", endPoint: "Khatu Shyam Ji Temple", distanceKm: 89.6, duration: "Approx. 1.5-2 hrs", cost: "N/A" },
      { mode: "Train", startPoint: "Reengus Junction", endPoint: "Khatu Shyam Ji Temple", distanceKm: 17, duration: "Approx. 30 mins", cost: "N/A" }
    ],
    accommodation: [
      { type: "Hotel", location: "Hotel Lakhdatar, approx. 0.1 km from temple", costRange: "Verify current tariff", bookingInfo: "Close to temple." }
    ],
    gates: [],
    facilities: [
      { name: "Locker / Cloak Room", description: "Cloakroom/locker services available in pilgrimage area.", isAvailable: true },
      { name: "Shoe Stand", description: "Footwear deposit facilities available.", isAvailable: true },
      { name: "Drinking Water", description: "Free drinking-water points available.", isAvailable: true },
      { name: "Toilets", description: "Public toilets available around temple facilities.", isAvailable: true },
      { name: "Restaurants / Food", description: "Isudhi Restaurant/Cafe and many vegetarian bhojanalayas operate.", isAvailable: true },
      { name: "Prasad", description: "Prasad available through temple-area counters and shops.", isAvailable: true }
    ],
    specialServices: [
      { name: "Festival Crowd Management", description: "Phalguna Mela has special route, queue and parking controls." }
    ],
    nearbyPlaces: [
      { name: "Shyam Kund", description: "Sacred kund in Khatu associated with the shrine." },
      { name: "Jeen Mata Temple", description: "Major nearby Shakti shrine in Sikar district." }
    ],
    images: { thumbnailImage: "https://www.taleof2backpackers.com/wp-content/uploads/2020/01/Khatu-Shyamji-Temple-Rajasthan-Peepal-tree.jpg" },
    management: {
      trustName: "Shri Shyam Mandir Committee (Regd.)",
      website: "https://shrishyamdarshan.in/",
      contactNumber: "01576-231182; 01576-231482"
    }
  },
  {
    slNo: "22",
    slug: "prem-mandir",
    generalInfo: {
      templeName: "Prem Mandir",
      templeDescription: "Prem Mandir in Vrindavan is a modern marble temple founded by Jagadguru Kripalu Parishat and dedicated to Radha-Krishna and Sita-Ram. The complex is known for illuminated evening displays, landscaped grounds and devotional tableaux. Entry is free, with separate morning and evening darshan sessions and a scheduled musical fountain/light presentation that changes seasonally.",
      location: "Vrindavan, Uttar Pradesh",
      deity: "Radha-Krishna and Sita-Ram",
      trekPoints: [],
      dressCode: "Modest traditional or formal clothing recommended."
    },
    timeInfo: {
      bestTime: "October - March",
      peakTime: "Evenings, weekends, Holi and Janmashtami"
    },
    footfall: { monthlyFootfalls: [] },
    registrationProcess: [],
    prerequisites: [],
    temperature: {
      monthlyTemperatures: [
        { month: "Jan", high: "22", low: "8" },
        { month: "Feb", high: "26", low: "11" },
        { month: "Mar", high: "32", low: "16" },
        { month: "Apr", high: "38", low: "21" },
        { month: "May", high: "42", low: "26" },
        { month: "Jun", high: "40", low: "28" },
        { month: "Jul", high: "35", low: "27" },
        { month: "Aug", high: "33", low: "26" },
        { month: "Sep", high: "34", low: "24" },
        { month: "Oct", high: "34", low: "20" },
        { month: "Nov", high: "29", low: "15" },
        { month: "Dec", high: "24", low: "10" }
      ]
    },
    templeTimings: {
      mandirTimings: {
        morningOpen: "08:30 AM",
        morningClose: "12:00 PM",
        eveningOpen: "04:30 PM",
        eveningClose: "08:30 PM"
      },
      gufaTimings: { morningOpen: "N/A", morningClose: "N/A", eveningOpen: "N/A", eveningClose: "N/A" },
      aartis: [
        { name: "Morning Darshan & Aarti", time: "08:30 AM" },
        { name: "Morning Bhog", time: "11:30 AM" },
        { name: "Morning Shayan Aarti", time: "12:00 PM" },
        { name: "Evening Aarti & Darshan", time: "04:30 PM" },
        { name: "Evening Bhog", time: "05:30 PM" },
        { name: "Parikrama", time: "07:00 PM" },
        { name: "Evening Shayan Aarti", time: "08:10 PM" }
      ]
    },
    transportation: [
      { mode: "Train", startPoint: "Mathura Junction", endPoint: "Prem Mandir", distanceKm: 9.4, duration: "Approx. 15-25 mins", cost: "₹230-₹280 by taxi" },
      { mode: "Road", startPoint: "Vrindavan town", endPoint: "Prem Mandir", distanceKm: 3, duration: "Approx. 10 mins", cost: "₹140-₹170 by taxi" }
    ],
    accommodation: [
      { type: "Hotel", location: "Hotel Shri Radha Nikunj, Raman Reti, approx. 0.2 km", costRange: "Verify current tariff", bookingInfo: "Close to Prem Mandir." }
    ],
    gates: [],
    facilities: [
      { name: "Shoe Stand", description: "Footwear must be removed before entering temple areas.", isAvailable: true },
      { name: "Drinking Water", description: "Drinking water available within the visitor complex.", isAvailable: true },
      { name: "Toilets", description: "Visitor toilets available.", isAvailable: true },
      { name: "Restaurants / Food", description: "Namaste Restaurant opposite Prem Mandir and Domino's in Ramanreti are nearby.", isAvailable: true },
      { name: "Prasad", description: "Prasad/devotional items available in complex.", isAvailable: true },
      { name: "Wheelchair / Accessibility", description: "Broad paved visitor areas with assistance available onsite.", isAvailable: true },
      { name: "Parking", description: "Parking available around visitor complex.", isAvailable: true }
    ],
    specialServices: [
      { name: "Musical Fountain / Light Show", description: "Summer approx. 07:30-08:00 PM; winter approx. 07:00-07:30 PM." }
    ],
    nearbyPlaces: [
      { name: "ISKCON Krishna Balaram Mandir", description: "Approx. 1 km away in Raman Reti." },
      { name: "Banke Bihari Mandir", description: "Major Vrindavan shrine a few kilometres away." }
    ],
    images: { thumbnailImage: "https://wanderon-images.gumlet.io/gallery/new/2025/08/08/1754651207820-prem-mandir-the-temple-of-love-in-vrindavan.jpg?auto=compress%2Cformat&w=1280" },
    management: {
      trustName: "Jagadguru Kripalu Parishat",
      website: "https://premmandir.org.in/",
      contactNumber: "+91 88824 80000"
    }
  },
  {
    slNo: "23",
    slug: "padmanabhaswamy-temple",
    generalInfo: {
      templeName: "Sree Padmanabhaswamy Temple",
      templeDescription: "Sree Padmanabhaswamy Temple in Thiruvananthapuram is dedicated to Lord Vishnu reclining on Anantha and is one of Kerala's most important Vaishnava shrines. Entry to the inner temple is restricted to Hindus and a strict traditional dress code is enforced. Darshan is offered in several short morning and evening windows rather than one continuous session.",
      location: "Thiruvananthapuram, Kerala",
      deity: "Lord Padmanabhaswamy (Vishnu)",
      trekPoints: [],
      dressCode: "Men: mundu/dhoti; shirts removed in inner areas. Women: saree, mundum-neriyathum, skirt/blouse or permitted traditional dress."
    },
    timeInfo: {
      bestTime: "October - February",
      peakTime: "Alpasi and Painkuni festivals; Vaikunta Ekadashi and holidays"
    },
    footfall: { monthlyFootfalls: [] },
    registrationProcess: [],
    prerequisites: [
      { name: "Entry Restrictions", description: "Entry to inner temple is restricted to Hindus." },
      { name: "Dress Code", description: "Traditional dress code is mandatory." }
    ],
    temperature: {
      monthlyTemperatures: [
        { month: "Jan", high: "30", low: "22" },
        { month: "Feb", high: "30", low: "23" },
        { month: "Mar", high: "30", low: "24" },
        { month: "Apr", high: "30", low: "25" },
        { month: "May", high: "29", low: "25" },
        { month: "Jun", high: "27", low: "24" },
        { month: "Jul", high: "27", low: "24" },
        { month: "Aug", high: "27", low: "24" },
        { month: "Sep", high: "28", low: "24" },
        { month: "Oct", high: "28", low: "24" },
        { month: "Nov", high: "28", low: "23" },
        { month: "Dec", high: "29", low: "23" }
      ]
    },
    templeTimings: {
      mandirTimings: {
        morningOpen: "03:30 AM",
        morningClose: "12:00 PM (multiple darshan windows)",
        eveningOpen: "04:30 PM",
        eveningClose: "07:20 PM"
      },
      gufaTimings: { morningOpen: "N/A", morningClose: "N/A", eveningOpen: "N/A", eveningClose: "N/A" },
      aartis: [
        { name: "Morning Windows", time: "03:30-04:45, 06:30-07:00, 08:30-10:00, 10:30-11:15, 11:45 AM-12:00 PM" },
        { name: "Evening Windows", time: "04:30-06:15 PM and 06:45-07:20 PM" }
      ]
    },
    transportation: [
      { mode: "Flight", startPoint: "Thiruvananthapuram International Airport", endPoint: "Temple", distanceKm: 4, duration: "Approx. 5-15 mins", cost: "₹310-₹380 by taxi" },
      { mode: "Train", startPoint: "Thiruvananthapuram Central", endPoint: "Temple", distanceKm: 1.2, duration: "Approx. 5-10 mins", cost: "N/A" }
    ],
    accommodation: [
      { type: "Pilgrim Accommodation", location: "Nelpura Hall / temple accommodation", costRange: "From approx. ₹200-₹250 per person", bookingInfo: "Limited inventory; check temple portal." }
    ],
    gates: [],
    facilities: [
      { name: "Locker / Cloak Room", description: "Deposit facility available for mobiles, cameras, bags.", isAvailable: true },
      { name: "Shoe Stand", description: "Footwear must be deposited before entry.", isAvailable: true },
      { name: "Drinking Water", description: "Drinking water available around complex.", isAvailable: true },
      { name: "Toilets", description: "Public facilities available in East Fort/temple area.", isAvailable: true },
      { name: "Prasad", description: "Temple prasadam available.", isAvailable: true }
    ],
    specialServices: [
      { name: "Traditional Dress Purchase/Rental", description: "Dhoti/mundu available from shops near entrance for visitors." }
    ],
    nearbyPlaces: [
      { name: "Kuthiramalika Palace Museum", description: "Historic palace immediately beside the temple." },
      { name: "Attukal Bhagavathy Temple", description: "Major Devi temple around 2-3 km away." }
    ],
    images: { thumbnailImage: "https://www.southindianroutes.com/storage/11309/trivandrum-featured-image1.webp" },
    management: {
      trustName: "Sree Padmanabhaswamy Temple Administration",
      website: "https://spst.in/",
      contactNumber: "0471-2450233"
    }
  },
  {
    slNo: "24",
    slug: "kamakhya-temple",
    generalInfo: {
      templeName: "Maa Kamakhya Temple",
      templeDescription: "Maa Kamakhya Temple on Nilachal Hill in Guwahati is one of India's most revered Shakti pilgrimage centres, associated with the yoni of the Goddess and the annual Ambubachi Mela. The sanctum contains a natural rock formation fed by an underground spring rather than an anthropomorphic idol. The temple has a daily midday closure and experiences extremely heavy queues during Ambubachi, Durga Puja and Navaratri.",
      location: "Nilachal Hill, Guwahati, Assam",
      deity: "Goddess Kamakhya",
      trekPoints: [],
      dressCode: "Modest traditional or formal clothing recommended."
    },
    timeInfo: {
      bestTime: "October - March",
      peakTime: "Ambubachi Mela (June), Durga Puja/Navaratri and weekends"
    },
    footfall: { monthlyFootfalls: [] },
    registrationProcess: [
      {
        name: "General Darshan Queue",
        description: "General queue is free. Walk-in allowed during visiting hours.",
        isMandatory: false,
        method: "Walk-in",
        cost: "Free",
        requiredDocs: "N/A",
        location: "Temple complex",
        website: "https://maakamakhya.org/",
        validity: "Current visit"
      }
    ],
    prerequisites: [],
    temperature: {
      monthlyTemperatures: [
        { month: "Jan", high: "23", low: "12" },
        { month: "Feb", high: "26", low: "15" },
        { month: "Mar", high: "30", low: "18" },
        { month: "Apr", high: "30", low: "21" },
        { month: "May", high: "30", low: "23" },
        { month: "Jun", high: "30", low: "25" },
        { month: "Jul", high: "31", low: "25" },
        { month: "Aug", high: "31", low: "25" },
        { month: "Sep", high: "30", low: "24" },
        { month: "Oct", high: "29", low: "22" },
        { month: "Nov", high: "27", low: "18" },
        { month: "Dec", high: "24", low: "14" }
      ]
    },
    templeTimings: {
      mandirTimings: {
        morningOpen: "Approx. 05:30 AM",
        morningClose: "01:00 PM",
        eveningOpen: "Approx. 02:30 PM",
        eveningClose: "Approx. 05:30 PM"
      },
      gufaTimings: { morningOpen: "N/A", morningClose: "N/A", eveningOpen: "N/A", eveningClose: "N/A" },
      aartis: [
        { name: "Morning Rituals / Darshan", time: "Morning; sanctum darshan begins after rituals" },
        { name: "Afternoon Darshan", time: "After midday reopening" }
      ]
    },
    transportation: [
      { mode: "Flight", startPoint: "Lokpriya Gopinath Bordoloi International Airport", endPoint: "Kamakhya Temple", distanceKm: 17.9, duration: "Approx. 30-45 mins", cost: "₹400-₹480 by taxi" },
      { mode: "Train", startPoint: "Guwahati Railway Station", endPoint: "Kamakhya Temple", distanceKm: 6.8, duration: "Approx. 10-20 mins", cost: "₹220-₹270 by taxi" }
    ],
    accommodation: [
      { type: "Hotel", location: "Hotel Shreemoyee Inn, very close to temple", costRange: "Verify current tariff", bookingInfo: "Book early during Ambubachi." }
    ],
    gates: [],
    facilities: [
      { name: "Locker / Cloak Room", description: "Deposit arrangements available around temple approach.", isAvailable: true },
      { name: "Shoe Stand", description: "Footwear deposit available near temple entrance.", isAvailable: true },
      { name: "Drinking Water", description: "Drinking water points available.", isAvailable: true },
      { name: "Toilets", description: "Public toilets available.", isAvailable: true },
      { name: "Restaurants / Food", description: "Vegetarian eateries operate on Kamakhya Mandir Road.", isAvailable: true },
      { name: "Prasad", description: "Prasad and ritual offerings available from authorized counters.", isAvailable: true }
    ],
    specialServices: [
      { name: "Ambubachi Mela", description: "Sanctum closes during Ambubachi and reopens after ritual purification." }
    ],
    nearbyPlaces: [
      { name: "Bhubaneswari Temple", description: "Hilltop shrine above Kamakhya with panoramic views." },
      { name: "Umananda Temple", description: "Island Shiva temple in the Brahmaputra." }
    ],
    images: { thumbnailImage: "https://captureatrip-cms-storage.s3.ap-south-1.amazonaws.com/Kamakhya_Temple_dbc4127c01.webp" },
    management: {
      trustName: "Maa Kamakhya Devalaya",
      website: "https://maakamakhya.org/",
      contactNumber: "0361-2734654; 0361-2734655"
    }
  },
  {
    slNo: "25",
    slug: "kedarnath-temple",
    generalInfo: {
      templeName: "Shri Kedarnath Temple",
      templeDescription: "Kedarnath Temple is a high-altitude Jyotirlinga shrine of Lord Shiva in Uttarakhand and one of the Char Dham pilgrimage destinations. The temple is accessible seasonally, normally from spring to autumn, and the final approach requires a roughly 16-17 km mountain trek from Gaurikund unless an authorized pony, palki or helicopter service is used. Char Dham registration is mandatory in 2026. Weather changes rapidly, so pilgrims need warm and rain-protective clothing, suitable footwear and sufficient fitness for altitude and trekking conditions.",
      location: "Kedarnath, Rudraprayag, Uttarakhand",
      deity: "Lord Kedarnath (Shiva)",
      trekPoints: [
        { name: "Gaurikund", distanceKm: 0 },
        { name: "Jungle Chatti", distanceKm: 4 },
        { name: "Bheembali", distanceKm: 6 },
        { name: "Linchauli", distanceKm: 11 },
        { name: "Kedarnath Temple", distanceKm: 17 }
      ],
      dressCode: "Warm layered clothing, rain protection and sturdy trekking shoes. Modest clothing inside the temple."
    },
    timeInfo: {
      bestTime: "May - June and September - October",
      peakTime: "Opening weeks (May-Jun), long weekends and festival dates"
    },
    footfall: { monthlyFootfalls: [] },
    registrationProcess: [
      {
        name: "Char Dham Yatra Registration",
        description: "Mandatory registration for Kedarnath yatra in 2026. Carry registration certificate/QR and photo ID.",
        isMandatory: true,
        method: "Online / App / Authorized Onsite Counters",
        cost: "Free",
        requiredDocs: "Valid government photo ID",
        location: "Authorized Char Dham registration system",
        website: "https://registrationandtouristcare.uk.gov.in/",
        validity: "For registered yatra/date rules"
      }
    ],
    prerequisites: [
      { name: "High Altitude", description: "People with serious heart, respiratory or mobility conditions should obtain medical advice before trekking." }
    ],
    temperature: {
      monthlyTemperatures: [
        { month: "Jan", high: "-7", low: "-14" },
        { month: "Feb", high: "-6", low: "-13" },
        { month: "Mar", high: "-3", low: "-11" },
        { month: "Apr", high: "1", low: "-8" },
        { month: "May", high: "5", low: "-4" },
        { month: "Jun", high: "9", low: "1" },
        { month: "Jul", high: "11", low: "5" },
        { month: "Aug", high: "11", low: "6" },
        { month: "Sep", high: "9", low: "2" },
        { month: "Oct", high: "4", low: "-3" },
        { month: "Nov", high: "0", low: "-8" },
        { month: "Dec", high: "-5", low: "-12" }
      ]
    },
    templeTimings: {
      mandirTimings: {
        morningOpen: "Approx. 04:00 AM",
        morningClose: "03:00 PM",
        eveningOpen: "05:00 PM",
        eveningClose: "09:00 PM"
      },
      gufaTimings: { morningOpen: "N/A", morningClose: "N/A", eveningOpen: "N/A", eveningClose: "N/A" },
      aartis: [
        { name: "Mahabhishek / Morning Pooja", time: "Early morning" },
        { name: "Sampurna Aarti", time: "Approx. 06:00 PM - 07:30 PM" }
      ]
    },
    transportation: [
      { mode: "Road", startPoint: "Jolly Grant Airport, Dehradun", endPoint: "Gaurikund", distanceKm: 238, duration: "Approx. 7-9 hrs", cost: "N/A" },
      { mode: "Trek", startPoint: "Gaurikund", endPoint: "Kedarnath Temple", distanceKm: 17, duration: "Approx. 6-10 hrs", cost: "Free on foot", extraInfo: "Ponies/palkis operate through prepaid systems." },
      { mode: "Helicopter", startPoint: "Phata / Sersi / Guptkashi helipads", endPoint: "Kedarnath helipad", duration: "Approx. 10 mins flight", cost: "Dynamic fare", extraInfo: "Book only through authorized portal." }
    ],
    accommodation: [
      { type: "GMVN Guest House", location: "Kedarnath New Guest House / Base Camp", costRange: "Check GMVN current tariff", bookingInfo: "Advance booking strongly recommended." }
    ],
    gates: [],
    facilities: [
      { name: "Locker / Cloak Room", description: "Luggage storage available at Gaurikund and along yatra route.", isAvailable: true },
      { name: "Shoe Stand", description: "Footwear storage available near temple entrance.", isAvailable: true },
      { name: "Drinking Water", description: "Water points available along the yatra route.", isAvailable: true },
      { name: "Toilets", description: "Free toilets provided along trek and base camp.", isAvailable: true },
      { name: "Restaurants / Food", description: "Basic vegetarian bhojanalayas and GMVN eateries operate.", isAvailable: true },
      { name: "Prasad", description: "Prasad available near temple.", isAvailable: true },
      { name: "Medical Facility", description: "Government Hospital Kedarnath and medical camps serve the shrine/trek.", isAvailable: true }
    ],
    specialServices: [
      { name: "Helicopter Service", description: "Seasonal helicopter service from authorized helipads.", price: "Dynamic fare" },
      { name: "Pony / Palki", description: "Prepaid pony and palki services available on trek.", price: "Seasonal tariff" }
    ],
    nearbyPlaces: [
      { name: "Bhairavnath Temple", description: "Uphill shrine near Kedarnath; seasonal access." },
      { name: "Gaurikund", description: "Roadhead and trek starting point about 17 km away." },
      { name: "Triyuginarayan Temple", description: "Historic Shiva-Parvati wedding site nearby." }
    ],
    images: { thumbnailImage: "https://www.india-tours.com/images/states-images/uttarakhand/kedarnath/kedarnath-mandir.jpg" },
    management: {
      trustName: "Shri Badarinath Kedarnath Temple Committee (BKTC)",
      website: "https://badrinath-kedarnath.gov.in/",
      contactNumber: "Office: +91-7302257116; General: 0135-2741600"
    }
  }
];
